import React from 'react';
import { NestedTable } from '../../NestedTable';
import { getMembers } from '../../NestedTable/utils';
import { SectionContainer } from '../../../SectionContainer';
import { SectionSubtitles } from '../SectionSubtitles';
import { Text } from '../../../PageElements/Text';
import { hasMembers } from '../utils';
import { StoreContext } from '../../../../appContext/StoreProvider';
import { OperationReturnValue } from '../../../../../types';

interface HTTPResponseTableProps {
  response: OperationReturnValue;
  prefix: string;
  pageName: string;
}

export const HTTPResponseTable = ({
  response,
  prefix,
  pageName,
}: HTTPResponseTableProps) => {
  const { store } = React.useContext(StoreContext);

  /*
  In REST operations, we do not have polymorphism. Only one return type is possible.
  Therefore, if the return type is in an array (in the new type schema according to the proto),
  we only consider the first element in the array.
   */
  const responseType = Array.isArray(response.type)
    ? response.type[0]
    : response.type;
  const returnObject = getMembers(store)(responseType);
  return (
    <SectionContainer title="Response Object">
      <SectionSubtitles
        subtitle={response.doc}
        prefix={prefix}
        pageName={pageName}
      />
      {hasMembers(returnObject) ? (
        <NestedTable
          tableDepth={0}
          params={returnObject.members}
          isResponse={true}
        />
      ) : (
        <Text dataHook="empty-section-container">Returns an empty object.</Text>
      )}
    </SectionContainer>
  );
};
